import { css } from '@emotion/css';

export const headers = css`
  padding: 25px 0 0 30px;
`;
